
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/USpaperMoney",
      function () {
        return require("private-next-pages/USpaperMoney/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/USpaperMoney"])
      });
    }
  